module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-flex bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "page-state"
  }, [_c('van-tabs', {
    attrs: {
      "swipeable": "",
      "swipe-threshold": 5,
      "line-width": '.6rem'
    },
    on: {
      "click": _vm.tabClick
    },
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, _vm._l((_vm.tabList), function(item, $index) {
    return _c('van-tab', {
      key: $index,
      attrs: {
        "title": item.title,
        "name": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel product-list"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cargo"
  }, [_vm._v("101")]), _vm._v(" "), _c('div', {
    staticClass: "Shortage"
  }, [_vm._v("缺货数 12")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-15 text-el fs-28 color-333"
  }, [_vm._v("山楂糖250g")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'exchangeProduct'
        })
      }
    }
  }, [_vm._v("换绑商品")])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot flex"
  }, [_c('div', {
    staticClass: "btn2 click"
  }, [_vm._v("全部补满")]), _vm._v(" "), _c('div', {
    staticClass: "btn click flex1",
    staticStyle: {
      "font-size": ".28rem"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("确定补货 "), _c('span', {
    staticClass: "fs-24"
  }, [_vm._v("(补货后，请关门盘点库存)")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-center mt-15 fs-26"
  }, [_c('div', {
    staticClass: "color-999"
  }, [_vm._v("补货数")]), _vm._v(" "), _c('div', {
    staticClass: "number color-fff bg-main"
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "color-main click"
  }, [_vm._v("补满")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73248453","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/supplyRecord/springSupplyCompare.vue
// module id = +VBY
// module chunks = 51